import React from "react";
import AssignConfirmationDialogComponent from "./assignConfirmationDialog.component";
import { useSelector } from "react-redux";

function AssignConfirmationDialogContainer({
  isOpen,
  handleClose,
  handleProceed,
  assignInfo,
}) {
  const lang = useSelector((state) => state.constant.languages);

  return (
    <AssignConfirmationDialogComponent
      isOpen={isOpen}
      handleClose={handleClose}
      handleSubmit={handleProceed}
      lang={lang}
      assignInfo={assignInfo}
    />
  );
}

export default AssignConfirmationDialogContainer;
